// Small, dependency-free formatting helpers for the indication UI.

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

export function formatCurrency(n: number): string {
  if (!Number.isFinite(n)) return '$0';
  return currencyFormatter.format(Math.round(n));
}

export function formatNumber(n: number, digits = 0): string {
  if (!Number.isFinite(n)) return '0';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(n);
}

/** Format a raw deductible dollar amount as "$25,000". */
export function formatDeductible(n: number): string {
  return formatCurrency(n);
}
